import { useContext } from 'react'

import { IndustriesFormContext } from './industries-context'

export function useIndustriesForm() {
  const ctx = useContext(IndustriesFormContext)
  if (!ctx) {
    throw new Error(
      'useIndustriesForm must be used within IndustriesFormProvider'
    )
  }
  return ctx
}
